"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
var close_1 = require("./close");
var print_1 = require("./print");
var download_1 = require("./download");
var related_1 = require("./related");
var message_1 = require("./message");
var share_1 = require("./share");
var more_1 = require("./more");
var quiz_1 = require("./quiz");
var switch_1 = require("./switch");
var add_1 = require("./add");
var minimizedVideo_1 = require("./minimizedVideo");
var pictureInPicture_1 = require("./pictureInPicture");
var expand_1 = require("./expand");
var arrowOpen_1 = require("./arrowOpen");
var arrowClose_1 = require("./arrowClose");
var chapter_1 = require("./chapter");
var hotspot_1 = require("./hotspot");
var answerOnAir_1 = require("./answerOnAir");
var screenRotation_1 = require("./screenRotation");
var autoScroll_1 = require("./autoScroll");
var replay_1 = require("./replay");
var closedCaptions_1 = require("./closedCaptions");
var genericFile_1 = require("./genericFile");
var presentation_1 = require("./presentation");
var image_1 = require("./image");
var document_1 = require("./document");
var excel_1 = require("./excel");
var pdf_1 = require("./pdf");
var zip_1 = require("./zip");
var volumeOn_1 = require("./volumeOn");
var volumeMute_1 = require("./volumeMute");
var spinner_1 = require("./spinner");
var detach_1 = require("./detach");
var attach_1 = require("./attach");
var audio_1 = require("./audio");
var chevronRight_1 = require("./chevronRight");
var check_1 = require("./check");
var transcript_1 = require("./transcript");
exports.Icons = {
    close: close_1.Close,
    print: print_1.Print,
    download: download_1.Download,
    related: related_1.Related,
    message: message_1.Message,
    share: share_1.Share,
    more: more_1.More,
    quiz: quiz_1.QuizIcon,
    switch: switch_1.Switch,
    add: add_1.Add,
    minimizedVideo: minimizedVideo_1.MinimizedVideo,
    pictureInPicture: pictureInPicture_1.PictureInPicture,
    expand: expand_1.Expand,
    arrowOpen: arrowOpen_1.ArrowOpen,
    arrowClose: arrowClose_1.ArrowClose,
    chapter: chapter_1.Chapter,
    hotspot: hotspot_1.Hotspot,
    answerOnAir: answerOnAir_1.AnswerOnAir,
    screenRotation: screenRotation_1.ScreenRotation,
    autoScroll: autoScroll_1.AutoScroll,
    replay: replay_1.ReplayIcon,
    closedCaptions: closedCaptions_1.ClosedCaptions,
    genericFile: genericFile_1.GenericFile,
    presentation: presentation_1.Presentation,
    image: image_1.Image,
    document: document_1.Document,
    excel: excel_1.Excel,
    pdf: pdf_1.PDF,
    zip: zip_1.Zip,
    volumeOn: volumeOn_1.VolumeOn,
    volumeMute: volumeMute_1.VolumeMute,
    spinner: spinner_1.Spinner,
    detach: detach_1.Detach,
    attach: attach_1.Attach,
    audio: audio_1.Audio,
    chevronRight: chevronRight_1.ChevronRight,
    check: check_1.Check,
    transcript: transcript_1.Transcript
};
//# sourceMappingURL=index.js.map